import { Button, Input, Typography } from "antd"
import { FormField } from "../../../components/Form/FormField"
import { useTranslation } from "react-i18next"
import { CSSProperties, useState } from "react"
import { SelectSearchFieldProps } from "../../../components/SelectSearchField/SelectSearchField"
import { StarFilled } from "@ant-design/icons"

interface DinamicSelectorWeightFormProps<T> extends SelectSearchFieldProps {
	data: Partial<any>[]
	loading?: boolean
	disabled?: boolean
	onAdd?: (value: { id: number | string; label: string; weight: string }) => void
	hideOrder?: boolean
	keepLabel?: boolean
	selectorStyle?: CSSProperties
	weightLabel?: string
}

export const DinamicSelectorWeightForm = <T extends any>({
	data,
	label,
	mandatory,
	loading,
	disabled,
	hideOrder,
	onAdd,
	placeholder,
	keepLabel,
	selectorStyle,
	weightLabel,
	...props
}: DinamicSelectorWeightFormProps<T>) => {
	const { t } = useTranslation("services", { keyPrefix: "form.serviceInfo" })
	const { t: tCommon } = useTranslation("common")
	const [item, setItem] = useState<any>({})

	return (
		<div>
			{label && (
				<div style={{ marginLeft: 4, marginBottom: 10 }}>
					{mandatory && (
						<span style={{ fontSize: 4.5, color: "red", position: "relative", top: -8, right: 4 }}>
							<StarFilled />
						</span>
					)}
					<Typography.Text>{label}</Typography.Text>
				</div>
			)}
			<div style={{ display: "flex", gap: 14, alignItems: "center" }}>
				<FormField.SelectSearch
					style={selectorStyle ?? { width: "200px" }}
					loading={loading}
					disabled={disabled}
					value={item?.id}
					placeholder={placeholder || tCommon("search")}
					options={data.map(data => ({
						value: data.id,
						label: !data.keepLabel ? `${data.id} - ${data.label}` : data.label,
						key: data.id
					}))}
					onChange={selectedOption => {
						// @ts-ignore
						setItem({ ...item, id: selectedOption.value, label: selectedOption.label })
					}}
					{...props}
				/>
				{!hideOrder && (
					<Input
						type="number"
						placeholder={weightLabel ?? t("weight").toString()}
						onChange={event =>
							setItem({ ...item, weight: event.target.value ? Number(event.target.value.trim()) : 0 })
						}
						value={item?.weight}
						style={{ width: "15%", marginTop: -24 }}
						disabled={disabled}
					/>
				)}
				<Button
					style={{ marginTop: -24 }}
					onClick={() => {
						if ((!hideOrder && (item?.weight === undefined || item?.weight === null)) || !item?.id) return
						onAdd && onAdd(item)
						setItem({})
					}}
					disabled={disabled}
				>
					<Typography.Text style={{ fontSize: 12, display: "flex", fontWeight: "normal" }}>{`+ ${t(
						"add"
					)}`}</Typography.Text>
				</Button>
			</div>
		</div>
	)
}
